import React from "react";
import { Spin } from "antd";

const CommonAuthButton = ({ type, className, disabled, loading, label, onClick}) => {
  
  const disabledStyle = {
    opacity: 0.5,
    cursor: "not-allowed",
    backgroundColor: "#0000000D",
    color: "#B3B4B6",
    fontSize: "16px",
    fontWeight: 500,
  };

  return (
    <button
      type={type || "button"}
      className={className}
      disabled={disabled}
      onClick={onClick}
      style={disabled ? disabledStyle : {}}
    >
      {loading ? <Spin size="small" /> : label}
    </button>
  );
};

export { CommonAuthButton };